/* 작성자 : 양창훈 */
export { default } from './SlideBox';
